import { i18n } from "@dehub/theme";

export function subReasonLabel (value?: string | null): string {
  if (!value) return "";
  return i18n.t(`returns:subReason.${value}`, { defaultValue: value });
}
